import FormErrorMessage from '@/app/common/components/FormErrorMessage'
import { inputVariants } from '@/app/common/components/input/inputVariants'
import Label from '@/app/common/components/Label'
import CurrencyInputField from 'react-currency-input-field'
import { Control, Controller, FieldErrors, UseFormWatch } from 'react-hook-form'
import { YesOrNoOptions } from '../../constants/constants'
import { VARIABLE_TUITION_OPTIONS } from '../../questions.constant'
import CheckboxQuestion from '../form_elements/CheckboxQuestion'
import RadioButtonQuestion from '../form_elements/RadioButtonQuestion'
import { SchoolFormValues } from '@/pages/providers/components/SchoolForm/schoolForm.schema.ts'
import FormSection from '@/common/components/FormSection.tsx'

type Props = {
  control: Control<SchoolFormValues>
  watch: UseFormWatch<SchoolFormValues>
  errors: FieldErrors<SchoolFormValues>
}

export default function ChargeTuitionSection(props: Props) {
  const { control, watch, errors } = props

  return (
    <div>
      {' '}
      <FormSection>
        {/* Charge Tuition */}
        <Controller
          name="TuitionSchema.chargeTuition"
          control={control}
          render={({ field }) => (
            <RadioButtonQuestion
              question={'Do you charge Tuition?'}
              options={YesOrNoOptions}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
        <FormErrorMessage
          message={errors.TuitionSchema?.chargeTuition?.message}
        />
      </FormSection>
      {watch('TuitionSchema.chargeTuition') === 'Yes' && (
        <div>
          <FormSection>
            <Label htmlFor="kindergartenTuition">
              Kindergarten Published Annual Non-Discounted Tuition
              <span className="text-red-500">*</span>
            </Label>
            <Controller
              name="TuitionSchema.kindergartenTuition"
              control={control}
              render={({ field }) => (
                <CurrencyInputField
                  id="kindergartenTuition"
                  decimalsLimit={2}
                  prefix="$"
                  className={inputVariants({
                    variant: 'text',
                  })}
                  value={field.value || ''}
                  onValueChange={(value: string | undefined) =>
                    field.onChange(value)
                  }
                  onBlur={field.onBlur}
                  placeholder="0"
                />
              )}
            />
            <FormErrorMessage
              message={errors.TuitionSchema?.kindergartenTuition?.message}
            />
          </FormSection>
          <FormSection>
            <Label htmlFor="elementaryTuition">
              Elementary (1-5) Published Annual Non-Discounted Tuition
              <span className="text-red-500">*</span>
            </Label>
            <Controller
              name="TuitionSchema.elementaryTuition"
              control={control}
              render={({ field }) => (
                <CurrencyInputField
                  id="elementaryTuition"
                  decimalsLimit={2}
                  prefix="$"
                  className={inputVariants({
                    variant: 'text',
                  })}
                  value={field.value || ''}
                  onValueChange={(value: string | undefined) =>
                    field.onChange(value)
                  }
                  onBlur={field.onBlur}
                  placeholder="0"
                />
              )}
            />
            <FormErrorMessage
              message={errors.TuitionSchema?.elementaryTuition?.message}
            />
          </FormSection>
          <FormSection>
            <Label htmlFor="middleSchoolTuition">
              Middle School (6-8) Published Annual Non-Discounted Tuition
              <span className="text-red-500">*</span>
            </Label>
            <Controller
              name="TuitionSchema.middleSchoolTuition"
              control={control}
              render={({ field }) => (
                <CurrencyInputField
                  id="middleSchoolTuition"
                  decimalsLimit={2}
                  prefix="$"
                  className={inputVariants({
                    variant: 'text',
                  })}
                  value={field.value || ''}
                  onValueChange={(value: string | undefined) =>
                    field.onChange(value)
                  }
                  onBlur={field.onBlur}
                  placeholder="0"
                />
              )}
            />
            <FormErrorMessage
              message={errors.TuitionSchema?.middleSchoolTuition?.message}
            />
          </FormSection>
          <FormSection>
            <Label htmlFor="highSchoolTuition">
              High School (9-12) Published Annual Non-Discounted Tuition
              <span className="text-red-500">*</span>
            </Label>
            <Controller
              name="TuitionSchema.highSchoolTuition"
              control={control}
              render={({ field }) => (
                <CurrencyInputField
                  id="highSchoolTuition"
                  decimalsLimit={2}
                  className={inputVariants({
                    variant: 'text',
                  })}
                  prefix="$"
                  value={field.value || ''}
                  onValueChange={(value: string | undefined) =>
                    field.onChange(value)
                  }
                  onBlur={field.onBlur}
                  placeholder="0"
                />
              )}
            />
            <FormErrorMessage
              message={errors.TuitionSchema?.middleSchoolTuition?.message}
            />
          </FormSection>
          <FormSection>
            <Controller
              name="TuitionSchema.variableTuition"
              control={control}
              render={({ field }) => (
                <CheckboxQuestion
                  question={'Do you have any forms of variable tuition?'}
                  options={VARIABLE_TUITION_OPTIONS}
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
            <FormErrorMessage
              message={errors.TuitionSchema?.variableTuition?.message}
            />
          </FormSection>
        </div>
      )}
    </div>
  )
}
